export default __webpack_public_path__ + "static/media/dv5.50aadf31.svg";